import { render, staticRenderFns } from "./ShareCard.vue?vue&type=template&id=225a3ee0"
import script from "./ShareCard.vue?vue&type=script&lang=js"
export * from "./ShareCard.vue?vue&type=script&lang=js"
import style0 from "./ShareCard.vue?vue&type=style&index=0&id=225a3ee0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports